import styled from 'styled-components';

export const FooterButtonContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: flex-end;
`;
